import { Subscription } from 'rxjs';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { UntypedFormGroup, UntypedFormControl, Validators, UntypedFormBuilder } from '@angular/forms';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { Router } from '@angular/router';
import { BaseForm } from 'projects/admin/src/app/classes/base-form';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { FormHelper } from 'projects/admin/src/app/shared/form-helper';
import { LANGUAGES } from 'projects/core/src/lib/constants';
import { RatingtypeModel } from 'projects/core/src/lib/models/ratingtype.model';
import { TranslocoService } from '@ngneat/transloco';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';
import { HelperService } from 'projects/admin/src/app/services/helper.service';
import { TEMPLATETYPES } from 'projects/core/src/lib/models/template.model';

@Component({
  selector: 'app-template-new',
  templateUrl: './template-new.component.html',
  styleUrls: ['./template-new.component.scss']
})
export class TemplateNewComponent extends BaseForm implements OnInit, OnDestroy {

  public loading = false;
  public languages: Array<SelectItem> = [];
  public types: Array<SelectItem> = [];
  public ratingtypes: Array<RatingtypeModel> = [];
  public subscriptions: Array<Subscription> = [];

  public form: UntypedFormGroup = this.fb.group({
    name: new UntypedFormControl(null, [Validators.required]),
    ratingtype: new UntypedFormControl(null, [Validators.required]),
    type: new UntypedFormControl('', [Validators.required]),
    language: new UntypedFormControl(null, [Validators.required]),
    documents_visible_observer: new UntypedFormControl(false),
    onsite: new UntypedFormControl(false),
    virtual: new UntypedFormControl(false),
  });

  constructor(
    private fb: UntypedFormBuilder,
    private ui: UiService,
    private api: ApiService,
    private router: Router,
    private auth: AuthStateService,
    private helper: HelperService,
    public transloco: TranslocoService
  ) {
    super();
  }

  ngOnInit(): void {
    if (this.auth.checkRightOrRedirect('admin.template.create')) {
      this.loading = true;
      this.types = FormHelper.getSelectList(TEMPLATETYPES, null, this.transloco);
      this.languages = FormHelper.getSelectList(LANGUAGES, null, this.transloco);
      this.api.getModels('ratingtypes').subscribe({
        next: (result: any) => {
          this.ratingtypes = [];
          result.data.forEach((ratingtype: any) => {
            this.ratingtypes.push(new RatingtypeModel().deserialize(ratingtype));
          });
          this.loading = false;
          this.ui.setFormFocus();
        }
      });
    }
    this.subscriptions.push(this.form.get('onsite').valueChanges.subscribe((value: boolean) => {
      if (value === true) {
        this.form.get('virtual').setErrors(null);
      }
    }));
    this.subscriptions.push(this.form.get('virtual').valueChanges.subscribe((value: boolean) => {
      if (value === true) {
        this.form.get('onsite').setErrors(null);
      }
    }));
  }

  ngOnDestroy(): void {
    this.helper.unsetSubscriptions(this.subscriptions);
  }

  onSubmit(): void {
    this.ui.hideMessage();
    if (this.form.valid === true) {
      this.submitting = true;
      const payload = {
        name: this.form.value.name,
        language: this.form.value.language,
        ratingtype: this.form.value.ratingtype.id,
        type: this.form.value.type,
        documents_visible_observer: this.form.value.documents_visible_observer,
        onsite: this.form.value.onsite,
        virtual: this.form.value.virtual,
      };
      this.api.saveModel('templates', null, payload).subscribe({
        next: (result: any) => {
          this.ui.toastSuccess(this.transloco.translate('common.messages.saved', { value: this.form.value.name }), this.transloco.translate('common.saved'));
          this.router.navigate(['/templates', result.data.id]);
        },
        error: (error: any) => {
          this.ui.showMessage('error', this.transloco.translate(error.message), this.transloco.translate('common.error'));
          FormHelper.setBackendErrors(this.form, error.fielderrors);
        }
      }).add(() => {
        this.submitting = false;
      });
    } else {
      this.ui.showMessage('error', this.transloco.translate('common.error_on_form_please_correct'), this.transloco.translate('common.error'));
      FormHelper.markFormAsDirty(this.form);
    }
  }

  onCancel(): void {
    this.router.navigate(['/templates']);
  }
}
